<template>
    <div class="pagamento">
        <b-container fluid>
            <div v-if="!showBonifico && !showPaypal">
                <b-row class="mt-2">
                    <b-col cols="12" class="text-center">
                        <h5 class="p-2 sfondo-giustup" style="width: max-content; display: inline">
                            Abbonati per un anno (senza rinnovi automatici) al costo di € 122,00 IVA inclusa
                        </h5>
                    </b-col>
                </b-row>

                <b-row class="mt-5">
                    <b-col sm="3">
                    </b-col>
                    <b-col sm="6">
                        La possibilità di abbonarsi è al momento disabilitata.
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>
<!--
                <b-row class="mt-5">
                    <b-col sm="3">
                    </b-col>
                    <b-col sm="6">
                        <b-form-input  v-model="denominazione" placeholder="Denominazione"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col sm="3">
                    </b-col>
                    <b-col sm="6">
                        <b-form-input  v-model="citta" placeholder="Città"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col sm="3">
                    </b-col>
                    <b-col sm="6">
                        <b-form-input  v-model="indirizzo" placeholder="Indirizzo"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col sm="3">
                    </b-col>
                    <b-col sm="6">
                        <b-form-input  v-model="cap" placeholder="CAP"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col sm="3">
                    </b-col>
                    <b-col sm="6">
                        <b-form-select v-model="provincia" :options="provinciaOptions"></b-form-select>
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col sm="3">
                    </b-col>
                    <b-col sm="6">
                        <b-form-input  v-model="email" type="email" placeholder="Email"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col sm="3">
                    </b-col>
                    <b-col sm="6">
                        <b-form-input  v-model="cf" placeholder="Codice Fiscale"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col sm="3">
                    </b-col>
                    <b-col sm="6">
                        <b-form-input  v-model="piva" placeholder="Partita IVA"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>-->
                <!--<b-row class="mt-3">
                    <b-col sm="3">
                    </b-col>
                    <b-col sm="6">
                        Soggetto al regime forfettario ex art. 1, commi da 54 a 89 della l. 190 del 2014:
                        <b-form-group>
                            <b-form-radio-group v-model="regimeForfettario" name="radio-sub-component">
                                <b-form-radio :value="true"><b>Sì</b></b-form-radio>
                                <b-form-radio :value="false"><b>No</b></b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>-->
                <!--
                <b-row class="mt-3">
                    <b-col sm="3">
                    </b-col>
                    <b-col sm="6">
                        <b-form-select v-model="tipoPagamento" :options="tipoPagamentoOptions"></b-form-select>
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col sm="3">
                    </b-col>
                    <b-col sm="6">
                        <b-form-input  v-model="telefono" placeholder="Telefono (preferibilmente mobile)"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                    </b-col>
                </b-row>
                <b-button variant="success" class="mt-5" style="min-width: 350px" @click.prevent="pagamento()">
                    Abbonati
                </b-button>
                -->
            </div>


            <bonifico v-if="showBonifico" />
            <paypal v-if="showPaypal" />
        </b-container>
    </div>
</template>

<script>
import province from './province.json';
import api from '../../services/service.js';
import pagServ from '../../services/pagamento.js';

export default {
  name: 'pagamento',
  data () {
    return {
        tipoPagamento: 'bonifico',
        tipoPagamentoOptions: [
          { value: 'bonifico', text: 'Bonifico' },
          { value: 'paypal', text: 'PayPal/Carta di credito' }
        ],
        provincia: null,
        provinciaOptions: [
            { value: null, text: "Provincia", disabled: true },
            ...province
        ],
        showBonifico: false,
        showPaypal: false,
        denominazione: "",
        citta: "",
        indirizzo: "",
        cap: "",
        email: "",
        cf: "",
        piva: "",
        telefono: ""
    }
  },
  methods: {
    pagamento() {
        //check params
        let err = "";
        if(this.denominazione === "")
            err = "Campo denominazione incompleto!";
        else if(this.citta === "")
            err = "Campo città incompleto!";
        else if(this.indirizzo === "")
            err = "Campo indirizzo incompleto!";
        else if(this.cap === "")
            err = "Campo CAP incompleto!";
        else if(this.provincia == null)
            err = "Campo provincia incompleto!";
        else if(this.email === "")
            err = "Campo email incompleto!";
        else if(this.cf === "")
            err = "Campo CF incompleto!";
        //else if(this.piva == "")
        //    err = "Campo Partita IVA incompleto!";
        if (err != "") {
            alert(err);
            return;
        }

        //send post request
        let data = {
            denominazione: this.denominazione,
            citta: this.citta,
            indirizzo: this.indirizzo,
            cap: this.cap,
            provincia: this.provincia,
            email: this.email,
            cf: this.cf,
            piva: this.piva,
            telefono: this.telefono,
            tipoPagamento: this.tipoPagamento,
            regimeForfettario: this.regimeForfettario
        }
        pagServ.pagamento(data).then(res => {
            console.log(res);

            //show info about payment
            this.$router.push({name: "InfoPagamento", params: { tipopagamento: this.tipoPagamento}});
        });
    }
  },
  async created() {
    await api.execute('get', 'utente/info');

    this.$parent._data.loaded = true;
  }
}
</script>

<style>

.sfondo-giustup {
  background-color: #008bc0;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagamento/Pagamento.vue